
import { NotificationManager } from "react-notifications";

class NotificationService {
  constructor() {
    this.apiMessage = [];

    //to use the notification plz use thisvariable
    this.apiMessage = [
      {
        api: "/bss/svc/admin/image-upload",
        success: "Admin Image uploaded successfully",
        failure: "Fail to upload!",
      },
      {
        api: "/bss/svc/operator/image-upload",
        success: "Operator Image uploaded successfully",
        failure: "Fail to upload!",
      },
      
      //       {
      //   api: "/enterprise/getCount",
      //   success: "Successfully get the count",
      //   failure: "Fail to get count from server",
      // },
      // {
      //   api: "/zone/getZoneInfo",
      //   success: "Successfully get the zone info",
      //   failure: "Fail to get zone info from server",
      // },
    ];
   
    this.discardList = [
      "bss/svc/admin/getall",
      "bss/refreshToken",
      "/bss/refreshToken",
      "/bss/swappingStation/getswapStationInfo",
      "/zone/getZoneInfo",
      "/enterprise/enterprise/status",
    ];
  }
  showNonBlacklisted(url, msg) {
    const apiUrlTrim = url?.split("?")[0];

    // const contains = this.discardList.some((element) => {
    //   if (apiUrlTrim.indexOf(element) !== -1) {
    //     return true;
    //   }

    //   return false;
    // });

    const idx = this.discardList.findIndex((x) => {
      apiUrlTrim?.includes(x);
    });
    if (idx === -1) {
      NotificationManager.success(msg);
    }
  }

  showNonBlacklistedError(url, msg) {
    const apiUrlTrim = url?.split("?")[0];

    const idx = this.discardList.findIndex((x) => {
      apiUrlTrim?.includes(x);
    });
    if (idx === -1) {
      NotificationManager.error(msg);
    }
  }
  showSuccessResponseNotification(apiUrl) {
    apiUrl = apiUrl?.split("?")[0];
    const idx = this.apiMessage.findIndex((x) => {
      return x.api === apiUrl;
    });
    if (idx === -1) {
      return;
    }
    NotificationManager.success(this.apiMessage[idx].success, "", 1000);
  }

  showErrorResponseNotification(apiUrl) {
    apiUrl = apiUrl?.split("?")[0];
    const idx = this.apiMessage.findIndex((x) => {
      return x.api === apiUrl;
    });
    if (idx === -1) {
      return;
    }

    NotificationManager.error(this.apiMessage[idx].failure, "", 1000);
  }
}

export default new NotificationService();
